<template>
    <div class="card-user-info" :class="{'card-user-info--reverse': reverse}">
        <a :href="memberUrl" class="card-user-info__link card-user-info__avatar-container">
            <img v-if="avatarUrl" class="card-user-info__avatar" :src="avatarUrl">
        </a>

        <span class="card-user-info__date" v-if="$slots['post-date']">
            <slot name="post-date"></slot> by
        </span>

        <div class="card-user-info__title-wrap" v-if="$slots['title']">
            <a :href="contentUrl" class="card-user-info__link card-user-info__title">
                <slot name="title"></slot>
            </a>
            <br>
            by
            <a :href="memberUrl" class="card-user-info__link">
                <span class="card-user-info__name">{{memberName}}</span>
            </a>
        </div>
        <a :href="memberUrl" class="card-user-info__link" v-else>
            <span class="card-user-info__name">{{memberName}}</span>
        </a>
    </div>
</template>

<script>
    export default {
        name: 'UserInfo',
        props: {
            memberName: String,
            memberUrl: String,
            avatarUrl: String,
            contentUrl: String,
            reverse: {
                type: Boolean,
                default: false,
                required: false
            }
        }
    }
</script>

<style lang="scss" scoped>
    .card-user-info {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        white-space: normal;
        width: 100%;
        max-width: 100%;

        &__avatar {
            max-width: 25px;
            max-height: 25px;
            border-radius: 50%;
            margin-right: 5px;
            flex: 0 0 auto;
        }

        &__name {
            color: #F43;
            font-style: normal;
            font-weight: normal;
            font-size: $dashboard-font-size-regular;
            line-height: 12px;
        }

        &--reverse {
            justify-content: space-between;


            .card-user-info__avatar-container {
                margin-right: 0;
                order: 9;
                flex: 0 0 30px;
            }
        }

        &__title {
            &-wrap {
                font-style: normal;
                font-size: 12px;
                line-height: 18px;
                flex: 1 0 auto;
                display: block;
                color: #999;
                max-width: calc(100% - 30px);


                .card-user-info__link {
                    flex: none;
                    display: inline;
                }

                .card-user-info__name {
                    color: #999;

                    &:hover {
                        color: #F43;
                    }
                }
            }

            color: #333;
            font-weight: bold;
        }

        &__link {
            flex: 0 0 auto;
            align-self: center;
            line-height: 12px;
            display: block;
        }

        &__date {
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 12px;
            color: #999999;
            margin-right: 3px;
            display: block;
            flex: 0 0 auto;
        }

        &:not(:last-child) {
            margin-bottom: $card-margin;
        }
    }
</style>
